import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { closeModal } from "../../redux/features/modalSlice";
import { successToast, errorToast } from "../../Utils/toast";
import { useUpdateCategoryMutation } from "../../redux/services/categoriesService/categories.Services";

function EditCategory({ data }) {
  const dispatch = useDispatch();
  const [updateCategory, { isLoading }] = useUpdateCategoryMutation();
  const [formData, setFormData] = useState({
    id: data?._id || data?.id,
    name: data?.name,
    description: data?.description,
    status: data?.status === "active" ? "Active" : "Inactive",
    image: null
  });

  const [preview, setPreview] = useState(
    data?.image
      ? `${process.env.REACT_IMAGE_URL}/${data.image}`
      : null
  );
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleUpdate = async () => {
    try {
      const form = new FormData();

      form.append("name", formData.name);
      form.append("description", formData.description);
      form.append("status", formData.status);

      if (formData.image) {
        form.append("image", formData.image);
      }
      const res = await updateCategory({
        id: formData.id,
        formData: form,
      }).unwrap();
      successToast(res?.message || "Updated Successfully 🚀");
      dispatch(closeModal());

    } catch (error) {

      console.log(error);

      errorToast(error?.data?.message || "Update Failed ❌");
    }
  };
  // ADD IMAGE CHANGE FUNCTION

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setFormData({
        ...formData,
        image: file,
      });

      setPreview(URL.createObjectURL(file));
    }
  };
  return (

    <div className="custom-modal-body">

      {/* NAME */}
      <div className="mb-3">

        <label>Category Name</label>

        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="form-control"
        />

      </div>

      {/* DESCRIPTION */}
      <div className="mb-3">

        <label>Description</label>

        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          className="form-control"
        />

      </div>

      {/* STATUS */}
      <div className="mb-3">

        <label>Status</label>

        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          className="form-control"
        >

          <option value="active">Active</option>

          <option value="inactive">Inactive</option>

        </select>

      </div>
      <div className="mb-3">
        <label>Image</label>
        <input
          type="file"
          className="form-control"
          accept="image/*"
          onChange={handleImageChange}
        />

        {preview && (
          <img
            src={preview}
            alt="preview"
            width="100"
            style={{
              marginTop: "10px",
              borderRadius: "10px",
            }}
          />
        )}
      </div>
      {/* BUTTONS */}
      <div className="d-flex gap-2">

        <button
          className="btn btn-secondary"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        <button
          className="btn btn-primary"
          onClick={handleUpdate}
          disabled={isLoading}
        >
          {isLoading ? "Updating..." : "Update"}
        </button>

      </div>

    </div>
  );
}

export default EditCategory;